import React, { useState } from 'react';
import { t } from 'src/i18n';
import { match, parseJSON } from 'src/utils/common.util';
import SuccessGreen from 'src/components/SuccessScreen/SuccessScreen';
import { useHistory } from 'react-router-dom';
import Routes from 'src/modules/Navigator/Navigator.route';
import VerifyIdentityView from '../VerifyIdentity.view';
import { Header } from '../VerifyIdentity.style';
import MainLogo from 'src/components/MainLogo/MainLogo';

const VerifyIdentityWrapper: React.FC = () => {
  const history = useHistory();
  const [stepVerify, setStepVerify] = useState<number>(1);

  const handleBackToSignIn = () => {
    history.push(Routes.SignIn);
  };

  const handleRenderForm = (formStep) => {
    const pattern = {
      0: (
        <>
          <Header>
            <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
          </Header>
          <SuccessGreen
            isShowSuccessIcon={false}
            isShowReturnIcon={false}
            titleMessage={t('setPassword.title.linkExpired')}
            descriptionMessage={t('setPassword.description.linkExpired')}
            buttonBackMessage={t('setPassword.successful.buttonBack')}
            handleGoBack={handleBackToSignIn}
          />
        </>
      ),
      1: <VerifyIdentityView setStepVerify={setStepVerify} />
    };

    return match(pattern)(formStep);
  };

  return <>{handleRenderForm(stepVerify)}</>;
};

export default VerifyIdentityWrapper;
